import moment from "moment";
import { useTranslation } from "react-i18next";
import { IoIosEye, IoIosEyeOff } from "react-icons/io";
import { amountFormat } from "../services/common.service";
import { Button, Divider, Empty, Tooltip } from "antd";

export default function SalaryAdvanceList({
  dataSource,
  accDetails
}) {
  const { t } = useTranslation();
  return (
    <>
 
      {dataSource.map((option, idx) => (
        <div key={idx}>
          <div className="account-row-data mb-2">
            <div className="list-row-display-item ">
              <div>
                <div className="mx-2 ministetement-ref">
                  {option.loanId || "-"}
                </div>
                <div className="mx-2 ministatement-desc">
                  {option?.cbsReferenceNumber || "-"}
                </div>
              </div>

              <div align="right">
                <div>
                {amountFormat(option.loanAmount, accDetails?.accountCurrency)}
                </div>
                <div>{option?.loanStatus ||"-"}
                </div>
                <div className="list-item-heading">
                {moment(option?.date).format("DD-MM-YYYY") || "-"}
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}


      {dataSource.length === 0 && (
        <Empty
       description={t("common.no_records_found", {
            defaultValue: "No Records Found",
          })}
        />
      )}
     
    </>
  );
}
